import { render, staticRenderFns } from "./HealthCheck.vue?vue&type=template&id=c6926374&"
import script from "./HealthCheck.vue?vue&type=script&lang=js&"
export * from "./HealthCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6926374')) {
      api.createRecord('c6926374', component.options)
    } else {
      api.reload('c6926374', component.options)
    }
    module.hot.accept("./HealthCheck.vue?vue&type=template&id=c6926374&", function () {
      api.rerender('c6926374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/HealthCheck.vue"
export default component.exports